var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5712 12.9835C29.5173 13.2472 30.2657 14.0238 30.5199 15.0055C30.9859 16.793 31 20.5 31 20.5C31 20.5 31 24.2216 30.534 25.9945C30.2798 26.9762 29.5315 27.7527 28.5854 28.0165C26.8768 28.5 20 28.5 20 28.5C20 28.5 13.1232 28.5 11.4146 28.0165C10.4685 27.7527 9.72015 26.9762 9.46598 25.9945C9 24.207 9 20.5 9 20.5C9 20.5 9 16.793 9.45186 15.0201C9.70603 14.0385 10.4544 13.2619 11.4005 12.9982C13.1091 12.5146 19.9859 12.5 19.9859 12.5C19.9859 12.5 26.8626 12.5 28.5712 12.9835ZM23.5019 20.5L17.7972 23.9286V17.0714L23.5019 20.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1615ebb3d5a7d48ec086b72551c82db3.svg";
export { ForwardRef as ReactComponent };